// src/components/home/FinalCTASection.js
import React from 'react';
import { Link } from 'react-router-dom';
import './FinalCTASection.css'; // Importe son propre CSS

function FinalCTASection() {
  return (
    <section className="final-cta-container">
      <h2>Prêt à concrétiser votre projet ?</h2>
      <p>
        Discutons de vos idées et voyons comment INFO COLAB peut vous aider à atteindre vos objectifs numériques.
        Contactez-nous dès aujourd'hui pour une consultation gratuite !
      </p>
      <Link to="/contact" className="btn btn-primary btn-cta-final">
        Parlons de votre projet <span className="cta-arrow" aria-hidden="true">&rarr;</span>
      </Link>
    </section>
  );
}

export default FinalCTASection;